import { render, staticRenderFns } from "./individual-prices.vue?vue&type=template&id=176a07f6&"
import script from "./individual-prices.vue?vue&type=script&lang=js&"
export * from "./individual-prices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports